import React from "react";

export default function Contact() {
  return (
    <div className="page">
      <h1>Contact Us</h1>
      <p>Get in touch with Bizverto for inquiries or support.</p>
    </div>
  );
}
